import { jsxs as m, jsx as r } from "@emotion/react/jsx-runtime";
import { ADMIN_ROLE as c } from "../../../../../constants/index.js";
import { useBusinessModalContext as l } from "../../../BusinessModalContext.js";
import { useMe as p } from "../../../hooks/useMe.js";
import { StyledStack as f } from "./Filters.styled.js";
import { BusinessSearch as n } from "./Fields/BusinessSearch/BusinessSearch.js";
import { SelectCities as a } from "./Fields/SelectCities/SelectCities.js";
import { SelectOrgs as d } from "./Fields/SelectOrgs/SelectOrgs.js";
const j = () => {
  const {
    filterVisibility: {
      query: t,
      city: o,
      org_id: e
    }
  } = l(), {
    data: i
  } = p(), s = i?.role === c && e;
  return /* @__PURE__ */ m(f, { children: [
    t && /* @__PURE__ */ r(n, {}),
    o && /* @__PURE__ */ r(a, {}),
    s && /* @__PURE__ */ r(d, {})
  ] });
};
export {
  j as Filters
};
